import { useEffect, useState } from 'react';
import { POLLING_PHOTON_STATS_SECONDS } from './config/config';
import { pollingMonitor, checkPhotonStats } from './utils/photon/stats';
import './PhotonStats.scss';


export const PhotonStats = ({ addMsg }) => {
  const [photonStats, setPhotonStats] = useState(null);
  const {
    photonState, playersOnline, playersInLobby, playersPlaying,
  } = photonStats || {};

  useEffect(() => {
    if (pollingMonitor.started) return;
    pollingMonitor.started = true;
    setInterval(
      () => setPhotonStats(checkPhotonStats({ addMsg })),
      POLLING_PHOTON_STATS_SECONDS * 1000,
    );
  }, []);

  return (
    <div className="photon-stats">
      {photonStats
      ? <p>
          {playersOnline >=0 && (
            <>
              <span>Playing: {playersPlaying}<span className="stats-separator">&nbsp;-&nbsp;</span></span>
              <span className="new-line-mobile">Lobby: {playersInLobby} <span className="stats-separator">&nbsp;-&nbsp;</span></span>
              <span className="new-line-mobile" id="online-users">Online: {playersOnline}</span>
            </>
          )}
          {playersOnline < 0 ? 'Connecting...' : ''}
          {/* <div id="photon-state">{photonState && `[${photonState}]`}</div> */}
        </p>
      : ''}
    </div>
  );
};
